import { CashFlowItem } from 'bus/cash/cashFlow/types';

import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../../api';
import { CashFlowItemCreateRequest } from '../cashFlow/types';

const changeCashFlowItem = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getCashFlowItemDetail: builder.query<CashFlowItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/CashFlowItem/${data.id}`,
      }),
    }),
    changeCashFlowItem: builder.mutation<void, CashFlowItem>({
      query: (data) => ({
        url: `/v1/CashFlowItem/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    createCashFlowItem: builder.mutation<void, CashFlowItemCreateRequest>({
      query: (data) => ({
        url: '/v1/CashFlowItem',
        method: 'POST',
        body: data,
      }),
    }),
    deleteCashFlowItemNow: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/CashFlowItem/${data.id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useChangeCashFlowItemMutation,
  useCreateCashFlowItemMutation,
  useDeleteCashFlowItemNowMutation,
  useGetCashFlowItemDetailQuery,
  useLazyGetCashFlowItemDetailQuery,
} = changeCashFlowItem;
